import React from 'react'
import { Icon } from 'antd'

import { ImagePreview } from '../../../../../../../../components'
import './AssetPreview.scss'

const formatAssetTypeLabel = assetType => {
  const label = String(assetType || '')
    .replace(/_/g, ' ')
    .trim()

  return label
    ? label.replace(/\b\w/g, character => character.toUpperCase())
    : 'Generated visual'
}

const getEntityAssetKeys = entity =>
  [
    entity?.id,
    entity?.entity_id,
    entity?.entityId,
    entity?.character_key,
    entity?.outfit_key,
    entity?.location_key,
    entity?.placeholder
  ]
    .filter(Boolean)
    .map(value => String(value))

const getAssetEntity = (asset, entities = []) => {
  const parentId =
    asset?.parent_entity_id ||
    asset?.parentEntityId ||
    asset?.entity_id ||
    asset?.entityId

  if (!parentId) return null

  const parentText = String(parentId)
  return entities.find(entity =>
    getEntityAssetKeys(entity).includes(parentText)
  )
}

const getAssetLabel = (asset, entities = [], fallbackLabel = 'Generated') => {
  const entity = getAssetEntity(asset, entities)
  const entityName =
    entity?.name ||
    entity?.placeholder ||
    asset?.parent_entity_id ||
    asset?.parentEntityId ||
    fallbackLabel
  const assetType = formatAssetTypeLabel(asset?.asset_type || asset?.assetType)

  return {
    title: entityName,
    subtitle: assetType
  }
}

const AssetPreview = ({
  assets,
  emptyLabel,
  entities = [],
  variant = '',
  previewAssets,
  latestAssetIds
}) => {
  const previewImagesList = React.useMemo(() => {
    const list = previewAssets || assets
    return list
      .map(item => {
        const itemUrl = item.image_url || item.imageUrl || item.thumbnail_url
        if (!itemUrl) return null
        const itemLabel = getAssetLabel(item, entities, emptyLabel)
        return {
          src: itemUrl,
          alt: `${itemLabel.title} - ${itemLabel.subtitle}`
        }
      })
      .filter(Boolean)
  }, [previewAssets, assets, entities, emptyLabel])

  return (
    <div
      className={`creative-direction-chat__asset-preview${
        variant ? ` creative-direction-chat__asset-preview--${variant}` : ''
      }`}
    >
      {assets.length ? (
        [...assets]
          .sort((a, b) => {
            const aLatest = latestAssetIds?.includes(a.id) ? 1 : 0
            const bLatest = latestAssetIds?.includes(b.id) ? 1 : 0
            return bLatest - aLatest
          })
          .map((asset, index) => {
          const label = getAssetLabel(asset, entities, emptyLabel)
          const imageUrl =
            asset.image_url || asset.imageUrl || asset.thumbnail_url

          const initialIndex = previewImagesList.findIndex(
            img => img.src === imageUrl
          )

          const isLatest = latestAssetIds?.includes(asset.id)

          return (
            <div
              className={`creative-direction-chat__asset-tile${
                isLatest ? ' creative-direction-chat__asset-tile--latest' : ''
              }`}
              key={asset.id || asset.image_url || asset.imageUrl || index}
            >
              {isLatest ? (
                <span className="creative-direction-chat__asset-tile-badge">
                  Latest
                </span>
              ) : null}
              {imageUrl ? (
                <ImagePreview
                  src={imageUrl}
                  alt={`${label.title} ${label.subtitle}`}
                  images={previewImagesList}
                  initialIndex={initialIndex >= 0 ? initialIndex : 0}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <Icon type="picture" />
              )}
              <div className="creative-direction-chat__asset-label">
                <strong>{label.title}</strong>
                <small>{label.subtitle}</small>
              </div>
            </div>
          )
        })
      ) : (
        <>
          {[0, 1, 2].map(index => (
            <div className="creative-direction-chat__asset-tile" key={index}>
              <Icon type="picture" />
              <div className="creative-direction-chat__asset-label">
                <strong>{emptyLabel}</strong>
                <small>Pending</small>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  )
}

export default AssetPreview
